import { reactive } from "vue";

// https://vuejs.org/guide/scaling-up/state-management.htm
// https://vuejs.org/guide/extras/reactivity-in-depth.html

enum BannerMode {
  left = "left",
  right = "right",
}

export const homePageComponent = reactive({
  tvTariff: false,
  bannerMode: BannerMode.left,
});
